import Api from '../../utils/api';
import {
  API_USER_COINS,
  API_USER_PROFILE,
  API_USER_UPDATE_PROFILE,
  API_USER_UPDATE_PASSWORD,
  API_USER_TREASURES,
  API_USER_DEFINITIONS,
  API_GAME_TEAM_DEFINITION,
} from '../../configs/apis';
import {
  USER_PROFILE_FETCH_REQUEST,
  USER_PROFILE_FETCH_SUCCESS,
  USER_PROFILE_SAVE_REQUEST,
  USER_PROFILE_SAVE_SUCCESS,
  USER_DEFINITIONS_FETCH_REQUEST,
  USER_DEFINITIONS_FETCH_SUCCESS,
  USER_DEFINITIONS_SAVE_REQUEST,
  USER_DEFINITIONS_SAVE_SUCESS,
  USER_UPDATE_PASSWORD_SUCCESS,
  USER_UPDATE_COINS,
  PLAYER_CONFIRM_MEDIA,
  USER_TREASURES_FETCH_REQUEST,
  USER_TREASURES_FETCH_SUCCESS,
  SIDEBAR_STATUS,
  SET_MEDIA_SETTINGS,
  HELP_STATUS,
  GAME_TEAM_DEFINITION_SUCCESS,
} from '../types';
import {showSavingOnButton, hideSavingOnButton} from '../../components/common/Loaders/ButtonLoader';
import {fetchDetails} from '../application';
import {handleError} from '../error';
import {appId} from '../../store';
import {forwardTo} from '../../utils';

export function fetchUserApi() {
  return Api.get(API_USER_PROFILE, {}, {appId});
}

export function updateUserCoins(coins) {
  return async (dispatch) => {
    try {
      return dispatch({type: USER_UPDATE_COINS, coins});
    } catch (error) {
      return dispatch(handleError(error));
    }
  };
}

export function fetchUserCoins() {
  return Api.get(API_USER_COINS, {}, {appId});
}

export function fetchUser() {
  return async (dispatch) => {
    try {
      dispatch({type: USER_PROFILE_FETCH_REQUEST});
      dispatch(fetchDetails(appId));

      const [user, coins] = await Promise.all([
        fetchUserApi(),
        fetchUserCoins(),
      ]);

      return dispatch({type: USER_PROFILE_FETCH_SUCCESS, user, coins});
    } catch (error) {
      return dispatch(handleError(error));
    }
  };
}

export function fetchUserDefinitions() {
  return async (dispatch) => {
    try {
      dispatch({type: USER_DEFINITIONS_FETCH_REQUEST});
      const response = await Api.get(API_USER_DEFINITIONS, {}, {appId});

      return dispatch({type: USER_DEFINITIONS_FETCH_SUCCESS, response});
    } catch (error) {
      return dispatch(handleError(error));
    }
  };
}

export function saveUserDefinitions(params) {
  return async (dispatch) => {
    try {
      const {data, gameId} = params;
      dispatch({type: USER_DEFINITIONS_SAVE_REQUEST});
      const response = await Api.put(API_USER_DEFINITIONS, {definitions: data}, {appId});

      if (gameId) {
        const fields = await Api.get(API_GAME_TEAM_DEFINITION, {}, {appId, gameId});
        dispatch({type: GAME_TEAM_DEFINITION_SUCCESS, fields});
      }

      return dispatch({type: USER_DEFINITIONS_SAVE_SUCESS, response});
    } catch (error) {
      return dispatch(handleError(error));
    }
  };
}

export function fetchUserTreasures() {
  return async (dispatch) => {
    try {
      dispatch({type: USER_TREASURES_FETCH_REQUEST});
      const response = await Api.get(API_USER_TREASURES, {}, {appId});
      return dispatch({type: USER_TREASURES_FETCH_SUCCESS, response});
    } catch (error) {
      return dispatch(handleError(error));
    }
  };
}

export function updateUser({redirectUrl, ...data}) {
  return async (dispatch) => {
    try {
      dispatch({type: USER_PROFILE_SAVE_REQUEST, data});
      dispatch(showSavingOnButton());
      const user = await Api.put(API_USER_UPDATE_PROFILE, data);

      dispatch({type: USER_PROFILE_SAVE_SUCCESS, user});
      if (redirectUrl) {
        forwardTo(redirectUrl);
      }
      return true;
    } catch (error) {
      return dispatch(handleError(error));
    } finally {
      dispatch(hideSavingOnButton());
    }
  };
}

export function updatePassword(data) {
  return async (dispatch) => {
    try {
      await Api.post(API_USER_UPDATE_PASSWORD, data);

      return dispatch({type: USER_UPDATE_PASSWORD_SUCCESS, data});
    } catch (error) {
      return dispatch(handleError(error));
    } finally {
      dispatch(hideSavingOnButton());
    }
  };
}

export function confirmMedia(params) {
  return {
    type: PLAYER_CONFIRM_MEDIA,
    ...params,
  };
}

export function setSidebarStatus(params) {
  return {
    type: SIDEBAR_STATUS,
    ...params,
  };
}

export function setMediaSettings(params) {
  return {
    type: SET_MEDIA_SETTINGS,
    ...params,
  };
}

export function setHelpStatus(params) {
  return {
    type: HELP_STATUS,
    ...params,
  };
}
